import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "services/common/rtkQueryConfig";

export const welcomePathApi = createApi({
  reducerPath: "welcomePathApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    createApplication: build.mutation<string, { createApplicationTemplate: CreateApplicationTemplateRequest; nhDealApplicationId: string, userId: string }>({
      query: ({ createApplicationTemplate, nhDealApplicationId, userId }) => ({
        url: `/Application/user-id/${userId}/nh-deal-application-id/${nhDealApplicationId}/createTemplate`,
        method: "POST",
        body:createApplicationTemplate,
      }),
    }),
    getWelcomePaths: build.query<Paths[], void>({
      query: () => `/Application/paths`,
    }),
    updateConsentStatus: build.mutation<void, {userId: string, nhDealApplicationId: string}>({
      query: ({ nhDealApplicationId, userId }) => ({
        url: `/user/${userId}/nh-deal-application-id/${nhDealApplicationId}/consent-status`,
        method: "POST",
      }),
    })
  }),
});
export const { useCreateApplicationMutation, useGetWelcomePathsQuery, useUpdateConsentStatusMutation } = welcomePathApi;

export interface CreateApplicationTemplateRequest {
  pathType: string;
}

interface Paths {
  id: number;
  title: string;
  image: string;
  description: string;
  timeDescription: string;
  path: string;
}
